import { TabIcon } from '../art/icons'
import { t } from '../strings/en'
import { goTab, TABS, type DockTab, type Tab } from './router'

/**
 * A tab's badge: a count (red: plays waiting on the Arcade; `soft`, white: a count that isn't a
 * call to act, like the Learn goal's answers still to go or the Crate's new finds), or a dot
 * (the Trip tab when there's a plan today). Owner, 23 Oct: they replace the Map's action card.
 */
export type DockBadge = { n: number; soft?: boolean; label: string } | { dot: true; label: string }

/**
 * `tabs`: the dock's tabs (a grown-up's adds Organiser, WI-19). `hidden`: tabs this trip doesn't
 * have (Learn without a language kit, B6).
 */
export function Dock({
  active,
  badges,
  tabs = TABS,
  hidden = [],
}: {
  active: Tab
  badges: Partial<Record<Tab, DockBadge | null>>
  tabs?: readonly DockTab[]
  hidden?: readonly Tab[]
}) {
  const shown = tabs.filter((tab) => !hidden.includes(tab))
  return (
    <nav className="dock" aria-label="Main" style={shown.length === 5 ? undefined : { gridTemplateColumns: `repeat(${shown.length}, 1fr)` }}>
      {shown.map((tab) => {
        const b = badges[tab]
        return (
          // The badge is read as the tab's description ("Learn", "8 right answers to go").
          <button key={tab} aria-label={t.tabs[tab]} aria-description={b?.label} aria-current={tab === active ? 'page' : undefined} onClick={() => goTab(tab)}>
            {b && 'dot' in b ? (
              <span className="badge dot" data-tab={tab} aria-hidden />
            ) : b ? (
              <span className={`badge${b.soft ? ' soft' : ''}`} data-tab={tab} aria-hidden>
                {b.n}
              </span>
            ) : null}
            <TabIcon tab={tab} />
            <span className="dock-label">{t.tabs[tab]}</span>
          </button>
        )
      })}
    </nav>
  )
}
